import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import Tag from '@atlaskit/tag';
import { FilterClickedEvent } from '@atlassian/mpac-analytics';
import { withFeatureFlags } from '@atlassian/mpac-ui';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getFilters } from "../../../../../../common/config/filters";
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from "../../../../../constants/analytics/events";
import { SEARCH } from "../../../../../constants/perspectives";

var CurrentFilter = /*#__PURE__*/function (_Component) {
  _inherits(CurrentFilter, _Component);

  var _super = _createSuper(CurrentFilter);

  function CurrentFilter() {
    var _this;

    _classCallCheck(this, CurrentFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "removeFilter", function () {
      var newFilters = _this.props.multi ? _this.props.filters.update(_this.props.filterKey, Immutable.Set(), function (f) {
        return f.remove(_this.props.filterValue);
      }) : _this.props.filters.delete(_this.props.filterKey);

      _this.props.createAnalyticsEvent({
        eventType: FilterClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON,
        objectType: OBJECT_TYPE_FILTER,
        objectId: _this.props.filterKey,
        source: EVENT_SOURCE,
        attributes: {
          currentPerspective: SEARCH,
          filterValue: _this.props.filterValue,
          selected: false
        }
      }).fire(EVENT_CHANNEL);

      _this.props.stateChangeRequested({
        filters: newFilters
      });

      return false;
    });

    return _this;
  }

  _createClass(CurrentFilter, [{
    key: "render",
    value: function render() {
      // Must be wrapped in a span otherwise React invariant violations are thrown in non-Chrome browsers
      // (i.e. those that use the custom element polyfill)
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Tag, {
        text: this.resolveFilterText(),
        removeButtonLabel: "Remove filter",
        onBeforeRemoveAction: this.removeFilter
      }));
    }
  }, {
    key: "resolveFilterText",
    value: function resolveFilterText() {
      var _this$props = this.props,
          filterKey = _this$props.filterKey,
          filterValue = _this$props.filterValue;
      var filter = getFilters({
        featureFlags: {
          enableJsdToJsm: this.props.enableJsdToJsm,
          enableDiscoverEcosystemCloudApps: this.props.enableDiscoverEcosystemCloudApps
        }
      }).get(filterKey);
      return filter.get('resolveCurrentFilterText') ? filter.get('resolveCurrentFilterText')({
        value: filterValue
      }) : filter.get('custom') ? filter.getIn(['customFilters', this.props.filterValue]).get('label') : this.props.filterValue;
    }
  }]);

  return CurrentFilter;
}(Component);

_defineProperty(CurrentFilter, "propTypes", {
  createAnalyticsEvent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  filterKey: PropTypes.string.isRequired,
  filterValue: PropTypes.string.isRequired,
  multi: PropTypes.bool.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  enableJsdToJsm: PropTypes.bool,
  enableDiscoverEcosystemCloudApps: PropTypes.bool
});

export default withAnalyticsEvents()(withFeatureFlags(CurrentFilter));